import { render } from "./ExpansionView.vue?vue&type=template&id=3690b860&scoped=true"
import script from "./ExpansionView.vue?vue&type=script&lang=js"
export * from "./ExpansionView.vue?vue&type=script&lang=js"

import "./ExpansionView.vue?vue&type=style&index=0&id=3690b860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3690b860"]])

export default __exports__